export default {"src":"/_next/static/media/1.d78fdd33.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};